import React, { memo } from 'react'

import EditCanvas from 'Pods/ThreeDStudio/Shared/ImageEditor/EditCanvas'
import { getCurrentSessionId, selectSessionId } from 'Pods/ThreeDStudio/Shared/Utils/imageRun'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { setImageAssistantSessionId, startNewImage } from 'Pods/ThreeDStudio/Store/actions/ui'
import { IMAGE_ASSISTANT_TAB } from 'Pods/ThreeDStudio/Store/constants'

import EmptyState from './Components/EmptyState/EmptyState'

function EditTab() {
  const editImage = useThreeDStudioStore(state => state.ui.editImage)
  const activeTab = useThreeDStudioStore(state => state.ui.imageAssistantTab)
  const sessionId = useThreeDStudioStore(selectSessionId)

  if (!editImage) {
    return <EmptyState />
  }

  // Key on the loaded image so loading a different image starts a fresh session,
  // while switching tabs (editImage unchanged) preserves the current one.
  return (
    <EditCanvas
      key={editImage.id}
      image={editImage}
      sessionId={sessionId}
      isActive={activeTab === IMAGE_ASSISTANT_TAB.EDIT}
      getSessionId={getCurrentSessionId}
      onSessionCreated={setImageAssistantSessionId}
      onStartNew={startNewImage}
    />
  )
}

export default memo(EditTab)
